import { Route } from '@angular/router';
import { CDFTIndexPage } from 'app/modules/cdft/pages/index/index.page';
import { CDFTViewPage } from 'app/modules/cdft/pages/view/view.page';
import { CDFTEditPage } from 'app/modules/cdft/pages/edit/edit.page';

export const cdftDashboardRoutes: Route[] = [
    {
        path: 'cdft',
        children: [],
    },
];

export const cdftDataManagementRoutes: Route[] = [
    {
        path: 'cdft',
        children: [
            {
                path: '',
                component: CDFTIndexPage,
            },
            {
                path: ':id',
                component: CDFTViewPage
            },
            {
                path: ':id/edit',
                component: CDFTEditPage
            },
        ],
    },
];

export const cdftConfigurationRoutes: Route[] = [
    {
        path: 'cdft',
        children: [],
    },
];
